import {Badge} from "@/instantsearch/components/Badge";
import {useAmountOfCurrentRefinements} from "@/instantsearch/hooks/useAmountOfCurrentRefinements";
import {useAmountOfHits} from "@/instantsearch/hooks/useAmountOfHits";
import {useInstantSearchUIContext} from "@/instantsearch/InstantSearchUIProvider";
import {useIsMobile} from "@/hooks/useIsMobile";
import {useTranslations} from "@/hooks/useTranslations";
import {Collapsible, Dialog} from "radix-ui";
import {type FC, type PropsWithChildren} from "react";

export const Sidebar: FC<PropsWithChildren> = ({children}) => {
    const {isActive, closePanel, toggle} = useInstantSearchUIContext();
    const tc = useTranslations();
    const amountOfCurrentRefinements = useAmountOfCurrentRefinements();
    const amountOfHits = useAmountOfHits();
    const isMobile = useIsMobile();

    return (
        <>
            {isMobile ? (
                <Dialog.Root open={isActive} modal={isActive} onOpenChange={() => toggle()}>
                    <Dialog.Portal>
                        <Dialog.Overlay className="ais-mobileMenu__overlay"/>
                        <Dialog.Content asChild>
                            <div className={'ais-mobileMenu__dialog'}>
                                <header className={"ais-mobileMenu__header"}>
                                    <Dialog.Title className={'ais-mobileMenu__title'} asChild={true}>
                                        <h2> {tc.algoliaFilter} <Badge value={amountOfCurrentRefinements}/></h2>
                                    </Dialog.Title>
                                    <Dialog.Close asChild>
                                        <button className="ais-mobileMenu__close">
                                            <i className="icon icon-close" aria-hidden={"true"}></i>
                                        </button>
                                    </Dialog.Close>
                                </header>
                                <section className={"ais-mobileMenu__content"}>
                                    {children}
                                </section>
                                <footer className={"ais-mobileMenu__footer"}>
                                    {amountOfHits > 0 && (
                                        <button className={"button button--primary"} onClick={() => closePanel()}>
                                            {amountOfHits} {tc.showHits}
                                        </button>
                                    )}
                                </footer>
                            </div>
                        </Dialog.Content>
                    </Dialog.Portal>
                </Dialog.Root>
            ) : (
                <Collapsible.Root open={isActive} asChild={true}>
                    <aside className="ais-sidebar">
                        <Collapsible.Content forceMount={true} className={'ais-sidebar__container'}>
                            <div className={"ais-sidebar__gap"} data-state={isActive ? "open" : "closed"}/>
                            <div className={"ais-sidebar__content"} data-state={isActive ? "open" : "closed"}>
                                <div className={"ais-sidebar__inner"}>
                                    {children}
                                </div>
                            </div>
                        </Collapsible.Content>
                    </aside>
                </Collapsible.Root>
            )}
            {/**
            NEVER DELETE THIS ELEMENT. IS REQUIRED FOR PERSIST THE STATE BETWEEN MOBILE AND DESKTOP!!!!
            */}
            <div hidden={true}>
                {children}
            </div>
        </>
    );

}